let baseUrl = '';
let BASE_ORL_ORDER = '';
switch (process.env.NODE_ENV){
  case "development"://本地
    // baseUrl = "http://self.platformapi.com/api/";  //阳仔本地
    // baseUrl = "http://managementdev.dsxindianshang.com/api/";   //123456
    // BASE_ORL_ORDER = "http://managementdev.dsxindianshang.com/api/";
    // baseUrl = "https://management.dsxindianshang.com/api/"
    // BASE_ORL_ORDER = "https://management.dsxindianshang.com/api/"
    baseUrl = "https://test-management-api.dsxindianshang.com/api/"
    BASE_ORL_ORDER = "https://test-management-api.dsxindianshang.com/api/"
    // baseUrl = "https://pro-management-api.dsxindianshang.com/api/"
    // BASE_ORL_ORDER = "https://pro-management-api.dsxindianshang.com/api/"
    break;
  case "test"://测试
    // baseUrl = "http://managementdev.dsxindianshang.com/api/"
    baseUrl = "https://test-management-api.dsxindianshang.com/api/"
    BASE_ORL_ORDER = "https://test-management-api.dsxindianshang.com/api/"
    break;
  case "production"://正式
    baseUrl = "https://management.dsxindianshang.com/api/"
    BASE_ORL_ORDER = "https://management.dsxindianshang.com/api/"
    break;
  case "preProduction"://预生产
    baseUrl = "https://pro-management-api.dsxindianshang.com/api/"
    BASE_ORL_ORDER = "https://pro-management-api.dsxindianshang.com/api/"
    break;
  default:
    baseUrl = "https://test-management-api.dsxindianshang.com/api/"//正常是不会走这里滴
    BASE_ORL_ORDER = "https://test-management-api.dsxindianshang.com/api/"//正常是不会走这里滴
    break;
}

export default {
  baseUrl,
  BASE_ORL_ORDER
}



// WEBPACK FOOTER //
// ./src/utile/config.js